import { render, staticRenderFns } from "./ViewWorkPage.vue?vue&type=template&id=2b230358&"
import script from "./ViewWorkPage.vue?vue&type=script&lang=js&"
export * from "./ViewWorkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports